var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRankThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23122"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20213",
    style: {
      fill: "none"
    },
    d: "M0 0h100v152H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17889",
    d: "M38.64 151.26a45.809 45.809 0 0 1-19.6-3.99A28.573 28.573 0 0 1 6.16 136l9.8-10.92a28.662 28.662 0 0 0 9.94 7.42 28.052 28.052 0 0 0 11.9 2.8q7 0 11.27-3.99a13.784 13.784 0 0 0 4.27-10.57 12.917 12.917 0 0 0-5.18-10.92q-5.18-3.92-14.28-3.92h-8.4V91.62h8.26q7.28 0 11.76-3.99a12.993 12.993 0 0 0 4.48-10.15q0-5.18-3.36-7.98t-9.8-2.8a26.493 26.493 0 0 0-11.76 2.66 29.924 29.924 0 0 0-9.66 7.56L6.02 65.86a34.152 34.152 0 0 1 14-11.06 46.257 46.257 0 0 1 19.32-4.06 39.635 39.635 0 0 1 16.1 3.08 24.715 24.715 0 0 1 10.78 8.61A22.149 22.149 0 0 1 70 75.24a23.433 23.433 0 0 1-3.92 13.3 26.972 26.972 0 0 1-11.48 9.38q9.52 3.36 14.21 9.38a23.413 23.413 0 0 1 4.69 14.84 27.077 27.077 0 0 1-4.34 15.26 28.551 28.551 0 0 1-12.25 10.22 43.28 43.28 0 0 1-18.27 3.64z",
    transform: "translate(10.48 -25.24)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankThree);
export default __webpack_public_path__ + "static/media/rank-three.899846af861ddcd6fd441f8f11d2ad8a.svg";
export { ForwardRef as ReactComponent };